import $ from 'jquery'

export default {
	namespace: 'default',
	beforeEnter() {

	},
	afterEnter() {

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
